<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content">
      <div class="tab-box-form">
        <div class="tab-box-left">
          <p style="text-align: left;"><b>部門/組織名</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="departmentName"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>郵便番号</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="departmentPostalCode"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>都道府県</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="departmentRegion"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>市区町村</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="departmentLocality"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>番地、ビル番号など</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="departmentStreet"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>説明</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="300" style="width: 100%;" class="input is-small" v-model="departmentDescription"/>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="createDepartment()" :disabled="!departmentName">追加する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import { Core as YubinBangoCore } from 'yubinbango-core'
export default {
  name: 'ModalCreateDepartment',
  componentName: 'ModalCreateDepartment',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      title: '部門の追加',
      departmentName: null,
      departmentDescription: null,
      parentDepartment: null,
      departmentPostalCode: null,
      departmentRegion: null,
      departmentLocality: null,
      departmentStreet: null
    }
  },
  watch: {
    isShowModal () {
      if (!this.isShowModal) {
        this.departmentName = null
        this.departmentDescription = null
        this.parentDepartment = null,
        this.departmentPostalCode = null,
        this.departmentRegion = null,
        this.departmentLocality = null,
        this.departmentStreet = null
      }
    },
    'departmentPostalCode' (newVal) {
      console.log(newVal)
      if (newVal.length >= 7) {
        new YubinBangoCore(newVal, (addr) => {
          if(addr.region) {
            this.departmentRegion = addr.region // 都道府県
          }
          if(addr.locality) {
            this.departmentLocality = addr.locality + addr.street // 市区町村
          }
        })
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('changeModal', false)
    },
    createDepartment () {
      this.$emit('createDepartment', {
        departmentName: this.departmentName,
        departmentDescription: this.departmentDescription,
        parentDepartment: this.parentDepartment,
        departmentPostalCode: this.departmentPostalCode,
        departmentRegion: this.departmentRegion,
        departmentLocality: this.departmentLocality,
        departmentStreet: this.departmentStreet
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
  border-right: solid 2px #ccc;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/ModalCreateDepartment.vue